
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/experience/dashboard",
      function () {
        return require("private-next-pages/experience/dashboard/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/experience/dashboard"])
      });
    }
  